module.exports = __webpack_public_path__ + "img/queue.68cdf027.svg";